import { getLang } from "@frend-digital/next/i18n";

export const PATHS = {
	Checkout: {
		Root: "/checkout",
		Shipping: "/checkout/shipping",
		Payment: "/checkout/payment",
	},
	Products: {
		Root: "/products",
		byLocale: (geo: string, path?: string) => {
			const locale = getLang(geo);
			return `/${locale === "no" ? "produkter" : "products"}/${path ?? ""}`;
		},
	},
	Account: {
		Root: "/account",
		Login: "/account/login",
		Register: "/account/register",
		Forgot: "/account/forgot-password",
	},
	Explore: {
		Root: "/explore",
	},
	Home: {
		Root: "/",
	},
} as const;

export const PAGE_SIZE = 16;

export const BASE_URL = new URL("https://scandinavianexplorer.no/");
export const SITE_NAME = "Scandinavian explorer";
